import Event from './event';
import TicketType from './ticket.type';
import Coupon from './coupon';
import { OrderStatus } from '../enums/orderStatus.enum';

export default interface Order {
  id: number;
  buyerName: string;
  buyerEmail: string;
  event: Event;
  tickets: TicketType[];
  discounted: number;
  subTotal: number;
  serviceFee: number;
  insuranceFee: number;
  totalToPay: number;
  coupons?: Coupon[] | null;
  createdAt?: Date | null;
  ticketIds: number[];
  slug: string;
  status: OrderStatus;
  free_event: boolean;
  promoter: string | null;
  creditCard: string;
  cardType: string;
  authorization: string;
}

export interface OrderWithPixelId extends Order {
  pixelId?: number;
}
